/** @module Enums */ /** typedoc */

export enum SubscriptionMigrationTypeEnum {
    Downgrade = 'Downgrade',
    FreeTrialConversion = 'FreeTrialConversion',
    FrequencyChange = 'FrequencyChange',
    PlanUpdate = 'PlanUpdate',
    Upgrade = 'Upgrade'
}
